// initial state
const desktop = 1200
const state = {
  menuIsOpen: window.innerWidth >= desktop
}

const mutations = {
  mutationIsOpen (state, event) {
    const eventTargetId = event.target.id
    if (eventTargetId === 'button-menu-mobile' || eventTargetId === 'button-menu-mobile-icon') {
      state.menuIsOpen = true
    } else {
      if (window.innerWidth < desktop) {
        state.menuIsOpen = false
      }
    }
  },
  menuIsOpenOnResize (state) {
    state.menuIsOpen = window.innerWidth >= desktop
  }
}

const actions = {
  menuOnResize ({ commit }) {
    function resizeThrottler () {
      commit('menuIsOpenOnResize')
    }
    window.addEventListener('resize', resizeThrottler, false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
